import apiService from '@/utils/api-client'
import config from '@/utils/appConfig'
import { validatePayload } from '@/utils/validate-payload'
import alertsResolutionSchema from '@contracts/api/dashboard/alertsResolution.request.schema.json'
import alertsSeveritySchema from '@contracts/api/dashboard/alertsSeverity.request.schema.json'
import casesSummarySchema from '@contracts/api/dashboard/casesSummary.request.schema.json'
import monitoringSummarySchema from '@contracts/api/dashboard/monitoringSummary.request.schema.json'
import riskBucketsAddressSchema from '@contracts/api/dashboard/riskBucketsAddress.request.schema.json'
import riskBucketsTxSchema from '@contracts/api/dashboard/riskBucketsTx.request.schema.json'

const DASHBOARD_BASE_URL = config.VUE_APP_API_USERS_URL

function getDashboardParams({
  from,
  to,
  coin,
  tz,
  bucket,
} = {}) {
  return {
    from,
    to,
    ...(coin && coin !== 'all' ? { coin } : {}),
    ...(tz ? { tz } : {}),
    ...(bucket ? { bucket } : {}),
  }
}

// The schemas are the ones gl-users-service validates with (gl-contracts submodule).
// `validatePayload` never rewrites the params — see VUE_APP_PAYLOAD_VALIDATION.
function getDashboard(url, schema, payload) {
  return apiService.get(url, {
    params: validatePayload(schema, getDashboardParams(payload), url),
    baseURL: DASHBOARD_BASE_URL,
  })
}

export default {
  getDashboardTxRiskBuckets(ctx, payload = {}) {
    return getDashboard('dashboard/risk-buckets/tx', riskBucketsTxSchema, payload)
  },

  getDashboardAddressRiskBuckets(ctx, payload = {}) {
    return getDashboard('dashboard/risk-buckets/address', riskBucketsAddressSchema, payload)
  },

  getDashboardAlertsSeverity(ctx, payload = {}) {
    return getDashboard('dashboard/alerts/severity', alertsSeveritySchema, payload)
  },

  getDashboardAlertsResolution(ctx, payload = {}) {
    return getDashboard('dashboard/alerts/resolution', alertsResolutionSchema, payload)
  },

  getDashboardCasesSummary(ctx, payload = {}) {
    return getDashboard('dashboard/cases/summary', casesSummarySchema, payload)
  },

  getDashboardMonitoringSummary(ctx, payload = {}) {
    return getDashboard('dashboard/monitoring/summary', monitoringSummarySchema, payload)
  },
}
